var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenRoundCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8518 11.2501L13.2518 21.8501C13.2053 21.897 13.15 21.9342 13.0891 21.9596C13.0282 21.9849 12.9628 21.998 12.8968 21.998C12.8308 21.998 12.7654 21.9849 12.7045 21.9596C12.6436 21.9342 12.5883 21.897 12.5418 21.8501L7.15181 16.4601C7.10494 16.4136 7.06774 16.3583 7.04236 16.2974C7.01698 16.2365 7.00391 16.1711 7.00391 16.1051C7.00391 16.0391 7.01698 15.9738 7.04236 15.9128C7.06774 15.8519 7.10494 15.7966 7.15181 15.7501L7.85181 15.0501C7.89829 15.0033 7.95359 14.9661 8.01452 14.9407C8.07545 14.9153 8.1408 14.9022 8.20681 14.9022C8.27281 14.9022 8.33816 14.9153 8.39909 14.9407C8.46002 14.9661 8.51532 15.0033 8.56181 15.0501L12.8918 19.3801L22.4418 9.83012C22.537 9.73787 22.6643 9.68628 22.7968 9.68628C22.9293 9.68628 23.0567 9.73787 23.1518 9.83012L23.8518 10.5401C23.8987 10.5866 23.9359 10.6419 23.9613 10.7028C23.9866 10.7638 23.9997 10.8291 23.9997 10.8951C23.9997 10.9611 23.9866 11.0265 23.9613 11.0874C23.9359 11.1483 23.8987 11.2036 23.8518 11.2501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoundCorrect);
export default __webpack_public_path__ + "static/media/green-round-correct.26fb6db43682b0854b48fcc4dfd6b994.svg";
export { ForwardRef as ReactComponent };